import { render, staticRenderFns } from "./ListTypeBenefits.vue?vue&type=template&id=06209170&"
import script from "./ListTypeBenefits.vue?vue&type=script&lang=js&"
export * from "./ListTypeBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports